import { SplitFactory } from '@splitsoftware/splitio';
import type SplitIO from '@splitsoftware/splitio/types/splitio';
import { AppContext } from 'next/app';
import { getAnonymousId } from '../util';

/**
 * whenever a feature is added to split.io
 * it should also be added to this enum
 * */
export enum Feature {
  CONFIRM_ONLINE_ACCOUNT = 'CONFIRM_ONLINE_ACCOUNT',
  LINK_INTERCOM_CHAT_HELP_V1 = 'Link_Intercom_Chat_Help_V1',
  CARRIER_LOGIN_COPY_DEC_2022 = 'Carrier_Login_Copy_Dec_2022',
  INCORRECT_LOGIN_INSTRUCTIONS = 'Incorrect_Login_Instructions',
  EXIT_PAGE = 'Exit_Page',
  EMAIL_COLLECTION_COPY_JAN_23 = 'Email_Collection_Copy_Jan_23',
  LANDING_PAGE_COPY_JAN_23 = 'Landing_Page_Copy_Jan_23',
  CONFIRMING_ADDITIONAL_CARRIERS = 'Confirming_Additional_Carriers',
  REMOVING_VIDEO_WALK_THROUGH_LANDING_PAGE = 'Removing_Video_Walk_Through_Landing_Page',
  // SHOW_EXPLAIN_SCREEN = 'Explain_Screen',
}

export class FeatureService {
  private static client: SplitIO.IClient;

  static async getFeatures(id: string): Promise<{
    [key in Feature]: boolean;
  }> {
    const allFeatures = Object.values(Feature);
    const defaultAllOff = allFeatures.reduce(
      (acc, cur) => ({ ...acc, [cur]: false }),
      {},
    ) as { [key in Feature]: boolean };

    if (!process.env.NEXT_PUBLIC_SPLIT_API_KEY) {
      console.error('No split api key found!!!');
      return defaultAllOff;
    }

    // const splitConfig = {
    //   core: {
    //     authorizationKey: process.env.SPLIT_API_KEY,
    //   },
    //   /** causing really noisy logs */
    //   debug: false, // && process.env.NODE_ENV === 'development'
    // };
    //
    // if (!FeatureService.client) {
    //   FeatureService.client = SplitFactory(splitConfig).client();
    // }
    //
    // await FeatureService.client.ready();

    // const treatments = FeatureService.client.getTreatments(id, allFeatures);
    const treatments: Record<string, any> = {};
    return allFeatures.reduce((acc, cur) => {
      if (treatments[cur] === 'on') {
        return { ...acc, [cur]: true };
      }
      return { ...acc, [cur]: false };
    }, {}) as { [key in Feature]: boolean };
  }
}
